import { Pipe, PipeTransform } from '@angular/core';
import { CreatureType } from '../enums/creature.type';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'creatureType',
  standalone: true,
})
export class CreatureTypePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: CreatureType): string {
    switch (value) {
      case CreatureType.Moonbits:
        return 'creature_types.moonbits';
      case CreatureType.Sharkman:
        return 'creature_types.sharkman';
      case CreatureType.Oregon:
        return 'creature_types.oregon';
      case CreatureType.Zunnie:
        return 'creature_types.zunnies';
      default:
        return 'creature_types.invalid';
    }
  }
}